import PaletteProvider from './PaletteProvider';

export default {
    __init__: ['fismPaletteProvider'],
    fismPaletteProvider: ['type', PaletteProvider],
};
